import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateReglement } from "../../../common/utils/validateUtils";
import { formatDate } from "../../../common/utils/FunctionsUtils";
import TextFieldCustomized from "../../../common/components/TextFieldCustomized";
import DatePickerCustomized from "../../../common/components/DatePickerCustomized";
import ButtonCustomized from "../../../common/components/ButtonCustomized";
import SelectCustomized from "../../../common/components/SelectCustomized";
import { postDonnesReglements } from "../state/TiActions";

function SuiviReglement(props) {
  const { id, devise, idDomiciliationBancaire, montantTotal } = props;
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const [reglement, setReglement] = useState("");
  const [modeReglement, setModeReglement] = useState("");
  const [numFormule, setNumFormule] = useState("");
  const [montant, setMontant] = useState("");
  const [date, setDate] = useState(null);
  const [errors, setErrors] = useState({});

  const reglements =
    tiReducer?.reglements?.map((type) => ({
      label: " (" + type.code + ") " + type.description,
      value: type.id,
    })) || [];

  const modeReglements =
    tiReducer?.modeReglements?.map((type) => ({
      label: " (" + type.code + ") " + type.description,
      value: type.id,
    })) || [];

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      handleEnvoyerClick();
    }
  };

  const handleEnvoyerClick = () => {
    const { isValid, errors } = validateReglement({
      numFormule,
      montant,
      montantTotal,
      date,
      modeReglement,
      reglement,
      devise,
    });
    setErrors(errors);
    let idTitreImportation = id.toString();
    let dateApplication = formatDate(date);
    let formule = numFormule;
    let idDevise = devise?.id;
    let idTypeReglement = reglement;
    let idModeReglement = modeReglement;

    const payload = {
      idTitreImportation,
      dateApplication,
      idDomiciliationBancaire,
      montant,
      formule,
      idDevise,
      idTypeReglement,
      idModeReglement,
    };

    if (isValid) {
      dispatch(postDonnesReglements(payload));
    }
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item md={4} xs={12}>
          <TextFieldCustomized
            label="Montant"
            onChange={setMontant}
            value={montant}
            error={errors.montant}
            obligatoire
            onKeyPress={handleEnterKeyPress}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <DatePickerCustomized
            label="Date"
            value={date}
            onChange={setDate}
            error={errors.date}
            obligatoire
            maxDate={new Date()}
            onKeyPress={handleEnterKeyPress}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <SelectCustomized
            label="Type du règlement"
            allowTyping={false}
            options={reglements}
            onChange={setReglement}
            error={errors.reglement}
            value={reglement}
            obligatoire
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <TextFieldCustomized
            label="Devise"
            disabled
            value={`(${devise?.code}) ${devise?.description}`}
            obligatoire
            onKeyPress={handleEnterKeyPress}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <TextFieldCustomized
            label="Numéro de la formule"
            onChange={setNumFormule}
            value={numFormule}
            error={errors.numFormule}
            obligatoire
            onKeyPress={handleEnterKeyPress}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <SelectCustomized
            label="Mode du règlement"
            allowTyping={false}
            options={modeReglements}
            onChange={setModeReglement}
            error={errors.modeReglement}
            value={modeReglement}
            obligatoire
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginTop: 1,
        }}
      >
        <ButtonCustomized
          title="Envoyer"
          variant="contained"
          onClick={handleEnvoyerClick}
        />
      </Box>
    </Box>
  );
}

export default SuiviReglement;
